<template>
  <div class="new-exam">
    <div class="form-container">
      <md-input-container
        v-if="!isRecollect"
        class="search"
      >
        <label class="search__label">ADICIONAR:</label>

        <search
          :fetch="searchExam"
          :min-chars="2"
          placeholder="Digite o nome ou código do exame que deseja adicionar…"
          class="search__input-container"
        />
      </md-input-container>
    </div>
    <p
      v-if="newExamsList.length === 0"
      class="search__message"
    >
      <template v-if="isExamProfiles">
        Você ainda não adicionou exames nesse perfil.
      </template>
      <template v-else>
        Nenhum exame adicionado para a OS.
      </template>
    </p>
    <template v-else>
      <div
        v-for="(item, index) in newExamsListData"
        :key="item.componentUniqUid"
        :class="['search-results__exams', 'exam-card-num-' + index]"
      >
        <component
          :is="examComponent[item.type]"
          :patient="patient"
          :index="index"
          :item="item"
          :disable-deletion="isRecollect"
          :is-exam-profiles="isExamProfiles"
        />
      </div>
    </template>
  </div>
</template>

<script>
import Search from '@/components/common/Search'
import CommonExam from '@/components/Exams/Create/CommonExam'
import AdditionalExam from '@/components/Exams/Create/AdditionalExam'
import CurveExam from '@/components/Exams/Create/CurveExam'
import MaternityExam from '@/components/Exams/Create/MaternityExam'
import PaternityExam from '@/components/Exams/Create/PaternityExam'
import LoadingExam from '@/components/Exams/LoadingExam'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ExamsNew',
  components: {
    'search': Search,
    'common-exam': CommonExam,
    'additional-exam': AdditionalExam,
    'curve-exam': CurveExam,
    'maternity-exam': MaternityExam,
    'paternity-exam': PaternityExam,
    'loading-exam': LoadingExam

  },
  props: {
    patient: Object,
    isExamProfiles: Boolean
  },
  computed: {
    ...mapGetters(['newExamsList', 'orderClone']),
    examComponent () {
      if (this.isExamProfiles) {
        return {
          'LOADING': 'loading-exam',       // Exame loading
          'STANDARD': 'common-exam',       // Exame comum
          'ADDITIONAL': 'common-exam',     // Exame complementar
          'CURVE': 'common-exam',          // Exame de curva
          'MATERNITY': 'common-exam',      // Exame de Maternidade,
          'PATERNITY': 'common-exam'       // Exame de Paternidade
        }
      }
      return {
        'LOADING': 'loading-exam',          // Exame loading
        'STANDARD': 'common-exam',          // Exame comum
        'ADDITIONAL': 'additional-exam',    // Exame complementar
        'CURVE': 'curve-exam',              // Exame de curva
        'MATERNITY': 'maternity-exam',      // Exame de Paternidade
        'PATERNITY': 'paternity-exam'       // Exame de Paternidade
      }
    },
    isRecollect () {
      let isRecollect = false
      if (this.$route.params && this.$route.params.requestid) isRecollect = true
      return isRecollect
    },
    newExamsListData () {
      let list = this.newExamsList
      if (this.$route.path.includes('/orders/recollect/')) {
        list.forEach(item => item.urgent = true)
      }
      if (this.orderClone) {
        list.forEach(function (value, i) {
          delete list[i]['id_exam_order']
          delete list[i]['additional_field_values']
          list[i]['urgent'] = false
          list[i]['notes'] = ''
        })
      }
      return list
    }
  },
  mounted () {
    this.getMostSentExam()
  },
  methods: {
    ...mapActions(['searchExam', 'openExamCard', 'getMostSentExam'])
  }
}
</script>

<style lang="scss">
  @import '../../../static/stylesheets/mixins';

  .new-exam {

    .md-input-container {
      &.search {
        margin: 0 0 20px;
        padding: 0;
        min-height: 39px;

        &:after {
          display: none;
        }

        .search {
          &__label {
            position: relative;
            display: flex;
            align-items: center;
            float: left;
            width: 105px;
            top: inherit;
            left: inherit;
            font-size: 13px;
            font-weight: 500;
            letter-spacing: 1.1px;
            color: #727272;
          }

          &__input-container {
            position: relative;
            display: block;
            width: calc(100% - 105px);
          }
        }
      }
    }

    .exam-curve__container .exam-curve__curves__item {
      width: 8%;
    }

    .search {
      &__message {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 10px 0;
        height: 110px;
        font-size: 15px;
        line-height: 1.5;
        color: #969696;
      }

      &-results__exams {
        margin: 22px 0 20px;

        .multiselect {
          &__content-wrapper {
            max-height: 150px !important;
          }
        }
      }
    }

  }

  @keyframes fadeout {
    0% {
      opacity: 1;
    }
    99% {
      opacity: 0;
    }
    100% {
      display: none;
    }
  }
  @keyframes fadein {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
</style>
